type LocalStorageObject = {
  data: unknown;
  timestamp: number;
  expirationTimestamp?: number;
};

const get = (key: string, parse?: boolean) => {
  const item = window.localStorage.getItem(key);

  return parse ? JSON.parse(item || '{}') : item;
};

const set = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

const remove = (key: string) => {
  window.localStorage.removeItem(key);
};

const clear = () => {
  window.localStorage.clear();
};

const saveObject = (key: string, data: unknown, expirationTimeInMs?: number) => {
  try {
    const now = Date.now();

    const objectWithTimestamp: LocalStorageObject = {
      data,
      timestamp: now,
    };

    if (expirationTimeInMs !== undefined) {
      objectWithTimestamp.expirationTimestamp = now + expirationTimeInMs;
    }

    set(key, JSON.stringify(objectWithTimestamp));
  } catch (error) {
    console.warn(`Failed to save object to localStorage with key: ${key}`, error);
  }
};

const getObject = <T = unknown>(key: string): T | null => {
  try {
    const storedData = get(key, true);

    if (!storedData || !storedData.timestamp) {
      return null;
    }

    if (storedData.expirationTimestamp !== undefined) {
      if (Date.now() > storedData.expirationTimestamp) {
        remove(key);

        return null;
      }
    }

    return storedData.data;
  } catch (error) {
    console.warn(`Failed to get object from localStorage with key: ${key}`, error);

    return null;
  }
};

export const localStorage = {
  get,
  set,
  remove,
  clear,
  saveObject,
  getObject,
};
